var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 42C42.3137 42 45 39.3137 45 36V20C45 16.6863 42.3137 14 39 14H37V10C37 7.79086 35.2091 6 33 6H11C7.68629 6 5 8.68629 5 12L5 22C5 23.1046 5.89543 24 7 24C8.10457 24 9 23.1046 9 22V17.6586C9.62556 17.8797 10.2987 18 11 18H39C40.1046 18 41 18.8954 41 20V22H38C34.6863 22 32 24.6863 32 28C32 31.3137 34.6863 34 38 34H41V36C41 37.1046 40.1046 38 39 38H27C25.8954 38 25 38.8954 25 40C25 41.1046 25.8954 42 27 42H39ZM33 14H11C9.89543 14 9 13.1046 9 12C9 10.8954 9.89543 10 11 10H33V14ZM38 26H41V30H38C36.8954 30 36 29.1046 36 28C36 26.8954 36.8954 26 38 26Z",
    fill: "#FFA800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 28C15 26.8954 14.1046 26 13 26C11.8954 26 11 26.8954 11 28V33H6C4.89543 33 4 33.8954 4 35C4 36.1046 4.89543 37 6 37H11V42C11 43.1046 11.8954 44 13 44C14.1046 44 15 43.1046 15 42V37H20C21.1046 37 22 36.1046 22 35C22 33.8954 21.1046 33 20 33H15V28Z",
    fill: "#FFA800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWallet);
export default __webpack_public_path__ + "static/media/add-wallet.bb2a143a.svg";
export { ForwardRef as ReactComponent };